const CircleProgress = ({ percentage, emoji, sColor, title, loading }) => {
  const radius = 120; // Radius of the circle
  const stroke = 20; // Thickness of the circle
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  return (
    <div className="relative flex justify-center items-center">
      <svg
        height={radius * 2}
        width={radius * 2}
        className="transform -rotate-90"
      >
        <circle
          stroke="#f3f3f3"
          fill="transparent"
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          stroke={sColor ? sColor : "#FFD93B"} // Yellow for progress
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={circumference + " " + circumference}
          style={{ strokeDashoffset }}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          className="transition-all duration-300 ease-out"
        />
      </svg>

      {/* Emoji and percentage text in the center */}
      <div className="absolute flex flex-col gap-1 items-center">
        <img src={emoji} height={70} width={70} alt="" /> {/* Emoji */}
        {loading ? (
          <div role="status" className="animate-pulse bg-gray-200 dark:bg-gray-700 rounded-lg shadow p-2  h-2 w-10"></div>
        ) : (
          <span className="text-md text-black font-bold">{percentage}%</span>
        )}
        {/* <span className="text-xs text-gray-400">{title}</span> */}
      </div>
    </div>
  );
};

export default CircleProgress;
